import styled from "styled-components";
import { ToggleProps, ToggleSliderProps } from "./types";
import { SPACING, QUERIES, ANIMATION } from "../../utils/constants";
import { BaseButton } from "../Button";

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.sm + SPACING.xs}px 0;

  @media ${QUERIES.tabletAndDown} {
    padding: ${SPACING.md}px 0;
    min-height: 60px;
  }
`;

export const ToggleInfo = styled.div`
  flex: 1;
`;

export const ToggleLabel = styled.div`
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--color-text-default);

  @media ${QUERIES.tabletAndDown} {
    font-size: var(--text-md);
  }
`;

export const ToggleDescription = styled.div`
  font-size: var(--text-xs);
  color: var(--color-gray-600);
`;

export const ToggleSwitch = styled(BaseButton)<ToggleProps>`
  position: relative;
  display: inline-flex;
  height: 1.5rem;
  width: 2.75rem;
  align-items: center;
  border: 0;
  padding: 0;
  border-radius: 9999px;
  cursor: pointer;
  transition: background-color ${ANIMATION.duration.normal}
    ${ANIMATION.easing.easeOut};
  background: ${(props) =>
    props.checked
      ? "var(--color-primary-color-background)"
      : "var(--color-gray-border)"};

  @media ${QUERIES.tabletAndDown} {
    height: 2rem;
    width: 3.5rem;
    min-width: 3.5rem;
    min-height: 2rem;
  }
`;

export const ToggleSlider = styled.span<ToggleSliderProps>`
  display: inline-block;
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  background-color: var(--color-white);
  transition: transform ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut};
  transform: ${(props) =>
    props.checked ? "translateX(1.25rem)" : "translateX(0.25rem)"};

  @media ${QUERIES.tabletAndDown} {
    height: 1.5rem;
    width: 1.5rem;
    transform: ${(props) =>
      props.checked ? "translateX(1.5rem)" : "translateX(0.25rem)"};
  }
`;
